import api from './api';

export const getContactsApi = (params) => api().get('/lenders-contacts', { params });
export const addNewContactApi = (data) => api().post('/lenders-contacts', data);
export const deleteContactsApi = (params) => api().delete('/lenders-contacts', { params });
export const updateContactsApi = (params) => api().put(`/lenders-contacts/${params.id}`, params.values);
